import * as React from 'react'
import { useMemo } from 'react'
import type { DescService } from '@bufbuild/protobuf'
import type { Client } from '@connectrpc/connect'
import { createClient } from '@connectrpc/connect'
import { TransportProvider, useTransport } from '@connectrpc/connect-query'
import { createConnectTransport } from '@connectrpc/connect-web'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const aiColorBaseUrl = import.meta.env.VITE_AI_COLOR_SIMULATION_SERVER ?? 'http://localhost:5250'

const transport = createConnectTransport({
  baseUrl: aiColorBaseUrl,
  interceptors: [],
  useHttpGet: true,
})
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
    },
  },
})

// useClientフック（company側から利用）
/** @public */
export function useClient<T extends DescService>(service: T): Client<T> {
  const transport = useTransport()
  return useMemo(() => createClient(service, transport), [service, transport])
}

// storybook用のProvider
export const ConnectProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <TransportProvider transport={transport}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </TransportProvider>
  )
}
